import { Layout } from "antd";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import ToastViewport from "../ui/ToastViewport";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Grid } from "antd";

const { Header, Content } = Layout;
const { useBreakpoint } = Grid;

export function AppShell({
  appMeta,
  navigation,
  activeKey,
  onNavigate,
  currentUser,
  onLogout,
  toasts,
  onDismissToast,
  children,
  setCurrentPage,
}) {
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.lg;
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location.pathname, setCurrentPage]);

  useEffect(() => {
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  const handleToggleSidebar = () => {
    if (isMobile) {
      setMobileSidebarOpen((prev) => !prev);
      return;
    }
    setSidebarCollapsed((prev) => !prev);
  };

  return (
    <Layout className={`app-layout ${isMobile ? "is-mobile" : ""}`}>
      <Sidebar
        appMeta={appMeta}
        navigation={navigation}
        activeKey={activeKey}
        onNavigate={onNavigate}
        onLogout={onLogout}
        setCurrentPage={setCurrentPage}
        collapsed={sidebarCollapsed}
        mobile={isMobile}
        open={mobileSidebarOpen}
        onRequestClose={() => setMobileSidebarOpen(false)}
        onToggleSidebar={handleToggleSidebar}
      />
      {isMobile && mobileSidebarOpen ? (
        <button
          type="button"
          className="app-sidebar-backdrop"
          aria-label="Close navigation"
          onClick={() => setMobileSidebarOpen(false)}
        />
      ) : null}

      <Layout className="app-main">
        <Header className="topbar">
          <Topbar
            currentUser={currentUser}
            onToggleSidebar={handleToggleSidebar}
            showSidebarToggle={isMobile}
          />
        </Header>
        <ToastViewport toasts={toasts} onDismiss={onDismissToast} />
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default AppShell;
